import { siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-white text-lg"></i>
                </div>
                <span className="font-heading font-bold text-lg text-white">
                  91精品影视
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                91精品影视是国内专业的影视资源下载平台，提供91影视看片下载、91精品影视下载、91影视资源下载，涵盖高清电影、热播剧集、综艺动漫等全品类资源，支持离线观看。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white text-sm mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="#hero" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">首页</a>
                </li>
                <li>
                  <a href="#carousel" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">专题推荐</a>
                </li>
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">主题索引</a>
                </li>
                <li>
                  <a href="#ranking" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">下载排行</a>
                </li>
                <li>
                  <a href="#app" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">下载工具</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white text-sm mb-4">
                资源分类
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">电影下载</a>
                </li>
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">剧集下载</a>
                </li>
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">综艺下载</a>
                </li>
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">动漫下载</a>
                </li>
                <li>
                  <a href="#index" className="text-foreground-400 hover:text-white text-sm transition-colors cursor-pointer">纪录片下载</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white text-sm mb-4">
                合作伙伴
              </h4>
              <p className="text-foreground-500 text-sm leading-relaxed">
                更多优质合作伙伴陆续加入中，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-sm">
              &copy; {new Date().getFullYear()} 91精品影视 - 91影视看片下载，91精品影视下载，91影视资源下载
            </p>
            <p className="text-foreground-600 text-xs">
              本站所有资源仅供学习交流，请下载后24小时内删除
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}